<h1>{{ "GENERAL.TRIALS" | appString }} - {{ "GENERAL.SECTIONSLOWERCASE" | appString }}</h1>
<div>

  <mat-form-field>
    <mat-label>{{ "GENERAL.FILTER" | appString }}</mat-label>
    <input matInput (keyup)="applyFilter($event)" #input>
  </mat-form-field>


  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource()" matSort>

      <ng-container matColumnDef="{{ COL_TRIAL }}">
        <th mat-header-cell class="text-2xl font-black" *matHeaderCellDef mat-sort-header> {{ "GENERAL.TRIALNUMBERSHORT" | appString }} </th>
        <td class="status-complete" mat-cell *matCellDef="let row"> {{row.trialName}} </td>
      </ng-container>

      <ng-container matColumnDef="{{ COL_SECTION }}">
        <th mat-header-cell class="font-bold text-2xl" *matHeaderCellDef mat-sort-header> {{ "GENERAL.SECTION" | appString }} </th>
        <td mat-cell class="status-complete" *matCellDef="let row"> {{row.section.name}} </td>
      </ng-container>

      <ng-container matColumnDef="{{ COL_BATCH }}">
        <th mat-header-cell class="font-bold text-2xl" *matHeaderCellDef mat-sort-header> {{ "GENERAL.BATCH" | appString }} </th>
        <td mat-cell class="status-complete" *matCellDef="let row"> {{row.batchNames}} </td>
      </ng-container>

      <ng-container matColumnDef="{{ COL_PEN }}">
        <th mat-header-cell class="font-bold text-2xl" *matHeaderCellDef mat-sort-header> {{ "GENERAL.PEN" | appString }} </th>
        <td mat-cell class="status-complete" *matCellDef="let row"> {{row.penNames}} </td>
      </ng-container>

      <ng-container matColumnDef="{{ COL_INITIAL_WEIGHING }}">
        <th mat-header-cell class="font-bold text-2xl" *matHeaderCellDef mat-sort-header> {{ "GENERAL.INITIALWEIGHING" | appString }} </th>
        <td mat-cell class="{{ isCompleted(row.initialWeighing.status) ? 'status-complete' : 'status-none' }}" *matCellDef="let row">
          {{ getWeighingAsText (row.initialWeighing) }} </td>
      </ng-container>

      <ng-container matColumnDef="{{ COL_FIRST_WEIGHING }}">
        <th mat-header-cell class="font-bold text-2xl" *matHeaderCellDef mat-sort-header> 1. {{ "GENERAL.INTERIMWEIGHING" | appString }} </th>
        <td mat-cell class="{{ isCompleted(row.firstWeighing.status) ? 'status-complete' : 'status-none' }}" *matCellDef="let row">
          {{ getWeighingAsText (row.firstWeighing) }} </td>
      </ng-container>

      <ng-container matColumnDef="{{ COL_SECOND_WEIGHING }}">
        <th mat-header-cell class="font-bold text-2xl" *matHeaderCellDef mat-sort-header> 2. {{ "GENERAL.INTERIMWEIGHING" | appString }} </th>
        <td class="{{ isCompleted(row.secondWeighing.status) ? 'status-complete' : 'status-none' }}"
          mat-cell *matCellDef="let row"> {{ getWeighingAsText (row.secondWeighing) }} </td>
      </ng-container>

      <ng-container matColumnDef="{{ COL_FINAL_WEIGHING }}">
        <th mat-header-cell class="font-bold text-2xl" *matHeaderCellDef mat-sort-header> {{ "GENERAL.ENDDATE" | appString }} </th>
        <td class="{{ isCompleted(row.finalWeighing.status) ? 'status-complete' : 'status-none' }}"
          mat-cell *matCellDef="let row"> {{ getWeighingAsText (row.finalWeighing) }} </td>
      </ng-container>

      <tr class="hover:bg-blue-600" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr class=" hover:cursor-pointer hover:bg-blue-600" mat-row *matRowDef="let row; columns: displayedColumns;" (click)="clickTrial(row)"></tr>

      <!-- Row shown when there is no matching data. -->

      <tr *matNoDataRow>
        <td class="mat-cell" colspan="4">{{ "GENERAL.NODATAMATCHESFILTER" | appString }}</td>
      </tr>

    </table>

    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Side" ></mat-paginator>
  </div>
</div>

